<template>
  <div>
    <h5>{{$t('contactFields')}}</h5>
    <custom-fields :is-output-data="false" :campaign="campaign" @save="save" title="campaignContactFields"></custom-fields>
  </div>
</template>

<script>
import CRUD from '@/mixins/CRUD';
import CustomFields from "./CustomFields";

export default {
  components: {CustomFields},
  props: ['campaign'],
  mixins: [CRUD],
  data() {
    return {
      defaultFormModel: {},
      data: null
    }
  },
  methods: {
    save(data) {
      this.data = data;
    },
    saveNext() {
      this.$emit('next', 'reportFields', this.data);
    }
  },
  i18n: {
    messages: {
      en: {
        contactFields: "Contact fields",
      },
      vi: {
        contactFields: "Thông tin liên hệ",
      }
    }
  },
}
</script>
